export class ResetPasswordConfirmation {
  current_password: any;
  password: any;
  password_confirmation: any;
}
